import styled from 'styled-components';
import {BGImageCenter} from '../../../../globalVariables/GlobalVariables';
import {dFlexCenter} from '../../../../globalVariables/GlobalFlex';
import {getToken, getPrimitive, getFontSize, getFontWeight} from '@tickchak/react-share/app';
import {pen} from '../../../../assets/symbols/symbols/Symbols.css';

export const imageContainer = styled.div<{variant?: 'row' | 'card'; $hasEditClick?: boolean}>`
    position: relative;
    ${p => p.variant === 'card' ? 'width: 70px;' : 'width: 100%;'}
    height: 100%;
    overflow: visible;
    ${p => p.variant === 'row' && `
        grid-column: 1;
        grid-row: 1;
    `}
    ${p => p.$hasEditClick && `
        &:hover {
            .editIcon {
                visibility: visible;
                opacity: 1;
            }
            
            .progress {
                visibility: hidden;
                opacity: 0;
            }
        }
    `}
`;

export const seriesImage = styled.div<{image?: string}>`
    width: 100%;
    height: 100%;
    ${p => p.image && BGImageCenter(p.image, 'cover')}
    border-start-start-radius: 5px;
    border-end-start-radius: 5px;
    ${p => p.image && 'background-size: cover;'}
`;

export const progress = styled.div`
    height: 30px;
    width: 30px;
    border-radius: 50%;
    background-color: ${getPrimitive('solids.white')};
    margin: auto;
    opacity: 1;
    visibility: visible;
    transition: all 300ms;
`;

export const progressContainer = styled.div`
    position: absolute;
    width: 35px;
    height: 35px;
    bottom: 33px;
    inset-inline-end: -15px;
    z-index: 1;
    cursor: pointer;
    border-radius: 50%;
    background-color: ${getPrimitive('solids.white')};
    ${dFlexCenter}
`;

export const percentageValue = styled.div`
    position: absolute;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: ${getPrimitive('solids.white')};
    color: ${getToken('color.text.default')};
    font-size: ${getFontSize('caption')};
    font-weight: ${getFontWeight('bold')};
    ${dFlexCenter}
    line-height: 1;
    z-index: 1;
`;

export const editIcon = styled.div`
    position: absolute;
    width: 35px;
    height: 35px;
    border-radius: 50%;
    background-color: ${getToken('color.brand.main')};
    ${BGImageCenter(pen, '12px')}
    cursor: pointer;
    visibility: hidden;
    opacity: 0;
    transition: all 300ms;
`;
